import { createApi, createCustomServiceCall } from '@thinknimble/tn-models'
import { z } from 'zod'
import axiosInstance from '../AxiosClient'
import { taskCreateShape, taskShape } from './models'

const TASKS_ENDPOINT = '/tasks/'

export const TaskApi = createApi(
  {
    client: axiosInstance,
    baseUri: TASKS_ENDPOINT,
    models: {
      entity: taskShape,
      create: taskCreateShape,
    },
  },
  {
    // Custom method to mark task as completed
    markCompleted: createCustomServiceCall(
      {
        inputShape: z.object({ id: z.string().uuid() }),
        outputShape: taskShape,
      },
      async ({ client, input, utils }) => {
        const res = await client.patch(`${TASKS_ENDPOINT}${input.id}/`, { status: 'completed' })
        return utils.fromApi(res.data)
      },
    ),
    // Custom list method to support query parameters
    listWithFilters: createCustomServiceCall(
      {
        inputShape: z
          .object({
            assignee: z.string().optional(),
            home_office: z.string().optional(),
          })
          .optional(),
        outputShape: z.any(), // Allow any response structure
      },
      async ({ client, input, utils }) => {
        const params = {}
        // Handle input - it could be undefined, empty object, or have values
        if (input) {
          if (input.assignee) {
            params.assignee = input.assignee
          }
          if (input.home_office) {
            params.home_office = input.home_office
          }
        }
        const res = await client.get(TASKS_ENDPOINT, { params })
        // Try to transform the response if possible, otherwise return raw data
        try {
          // Check if response is an array or has results property
          if (Array.isArray(res.data)) {
            return res.data.map((item) => (utils.fromApi ? utils.fromApi(item) : item))
          } else if (res.data.results && Array.isArray(res.data.results)) {
            return {
              ...res.data,
              results: res.data.results.map((item) => (utils.fromApi ? utils.fromApi(item) : item)),
            }
          }
          return res.data
        } catch (error) {
          // If transformation fails, return raw data
          return res.data
        }
      },
    ),
  },
)
